import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  RoutesRecognized,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { loadFeatureAccess } from 'mojo-feature-access';
import { featureFlagsGetAll } from 'mojo-feature-flags';
import { filter, first, pairwise } from 'rxjs/operators';

import {
  licenseConfigurationGet,
  licenseGetName,
  licenseLoadExtensions,
} from '@core/settings/license-configuration';
import { addMainOutletRoute } from '@shared/navigation-history/navigation-history.actions';

@Injectable()
export class AppResolver {
  constructor(private store: Store<{}>, private router: Router) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.store.dispatch(addMainOutletRoute({ lastPage: state.url }));
    this.router.events
      .pipe(
        filter((event): event is RoutesRecognized => event instanceof RoutesRecognized),
        pairwise(),
      )
      .subscribe(([previous, current]: [RoutesRecognized, RoutesRecognized]) => {
        if (!previous.urlAfterRedirects.includes('modal')) {
          this.store.dispatch(addMainOutletRoute({ lastPage: previous.urlAfterRedirects }));
        }
      });

    this.store.dispatch(licenseConfigurationGet());
    this.store.dispatch(licenseGetName());
    this.store.dispatch(licenseLoadExtensions());
    this.store.dispatch(loadFeatureAccess());
    return this.store.select(featureFlagsGetAll).pipe(first());
  }
}
